import React, { useRef } from "react";
import logo from "../../../../../assest/logo-my-color-event.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const CustomerView = ({ products }) => {
  const allProducts = products.products;

  const pdfRef = useRef();

  const generatePdf = async () => {
    const input = pdfRef.current;
    const pdf = new jsPDF("p", "mm", "a4"); // A4 dimensions: 210 x 297 mm
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 20; // 20mm margin on all sides

    // Capture content of the entire page using html2canvas
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const contentWidth = pageWidth - 2 * margin; // Content width minus margins
    const contentHeight = (canvas.height * contentWidth) / canvas.width; // Maintain aspect ratio

    let currentHeight = 0;

    while (currentHeight < contentHeight) {
      pdf.addImage(
        imgData,
        "PNG",
        margin, // X position (left margin)
        margin - currentHeight, // Y position (top margin adjusted by currentHeight)
        contentWidth,
        contentHeight
      );

      currentHeight += pageHeight - 2 * margin; // Subtract top and bottom margins

      if (currentHeight < contentHeight) pdf.addPage();
    }

    pdf.save("CustomerView.pdf"); // Save PDF
  };

 return (
    <div className="bg-blue-100 min-h-screen p-5">
      {/* PDF Download Button */}
      <div className="text-center mt-5">
        <button
          onClick={generatePdf}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Download PDF
        </button>
      </div>
      <div
        ref={pdfRef}
        style={{
          width: "794px",
          border: "1px solid black",
          margin: "auto",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          background: "#fff",
        }}
      >
        <div className="border-b border-b-gray-500  flex justify-between items-center w-full p-5">
          <div className="flex flex-row gap-5 items-center justify-center">
            <img className="w-32 h-32" src={logo} alt=""></img>
            <div className="flex flex-col gap-1">
              <h1 className="text-2xl font-semibold font-montserrat text-gray-800 ">
                My color event
              </h1>

              <h1 className="text-sm text-gray-900 font-roboto">
                1565 Monroe Turnpike Monroe, CT 06468
              </h1>
              <h1 className="text-sm text-gray-900 font-roboto">
                P: (203) 559-2621
              </h1>
              <h1 className="text-sm text-blue-500 font-roboto">
                info@mycolorevents.com
              </h1>
              <h1 className="text-sm text-blue-500 font-roboto">
                mycolorevents.com
              </h1>
            </div>
          </div>
          <div>
            <h1 className="text-2xl font-semibold font-roboto text-blue-500">
              Quote
            </h1>
            <h1 className="text-lg font-roboto text-gray-900">
              Quote : {products.paymentId}
            </h1>
          </div>
        </div>
        <div className="p-5 flex justify-between ">
          <div className="w-[50%]">
            <h1 className="text-xl font-roboto font-semibold text-gray-800">
              Sales Lead
            </h1>
            <h1 className="text-sm text-gray-900 font-roboto mt-2">
              <span className="font-semibold">Name:</span> Yousuf Mila
            </h1>
            <h1 className="text-sm text-gray-900 font-roboto">
              <span className="font-semibold">Email :</span> esbteam1@gmail.com
            </h1>
          </div>
          <div className="flex justify-start flex-col w-[70%]">
            <h1 className="text-xl font-semibold font-roboto text-gray-800">
              Bill To
            </h1>

            <div className="flex justify-between border border-gray-500 rounded p-2">
              <div>
                <h1 className="text-sm font-roboto text-gray-900 mt-2">
                  <span className="font-semibold">Name:</span>{" "}
                  {products.firstName} {products.lastName}
                </h1>
                <h1 className="text-sm font-roboto text-gray-900">
                  <span className="font-semibold">Phone :</span>{" "}
                  {products.phoneNumber}
                </h1>
                <h1 className="text-sm font-roboto text-gray-900">
                  <span className="font-semibold">Email :</span>{" "}
                  {products.email}
                </h1>
              </div>
              <div>
                <h1 className="text-sm font-roboto text-gray-900">
                  <span className="font-semibold">Venue :</span>{" "}
                  {products.VenueName}
                </h1>
                <h1 className="text-sm font-roboto text-gray-900">
                  <span className="font-semibold">Address One :</span>{" "}
                  {products.VenueStreetAddressOne}
                </h1>
                <h1 className="text-sm font-roboto text-gray-900">
                  <span className="font-semibold">Address Two :</span>{" "}
                  {products.VenueStreetAddressTwo}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="p-5 flex flex-col justify-between ">
          <table class="w-full  text-left rtl:text-right  dark:text-gray-400">
            <thead class="text-sm font-roboto text-gray-600 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-3 py-2 ">
                  Item
                </th>

                <th scope="col" class="px-3 py-2">
                  Price
                </th>
                <th scope="col" class="px-3 py-2">
                  Quantity
                </th>
                <th scope="col" class="px-3 py-2 ">
                  Sub Total
                </th>
                <th scope="col" class="px-3 py-2">
                  Tax
                </th>
                <th scope="col" class="px-3 py-2">
                  Discount
                </th>
              </tr>
            </thead>
            {allProducts.map((pro) => (
              <tbody>
                <tr class="bg-white  border-b dark:bg-gray-800 dark:border-gray-700 ">
                  <td class="px-6 py-4 text-sm font-roboto text-gray-800">
                    <span>{pro.title}</span>
                  </td>

                  <td class="px-6 py-4 text-sm font-roboto text-gray-800">
                    {pro.selectedPricingValue}
                  </td>
                  <td class="px-6 py-4 text-sm font-roboto text-gray-800">
                    {pro.quantity}
                  </td>
                  <td class="px-6 py-4 text-sm font-roboto text-gray-800">
                    {pro.discount || pro.tax ? (
                      <div className="flex flex-col gap-2">
                        <span>{Number(pro.modifyProductTotal).toFixed(2)}</span>
                        <span className="text-sm">
                          <del>{pro.productTotal}</del>
                        </span>
                      </div>
                    ) : (
                      <span>{pro.productTotal}</span>
                    )}
                  </td>
                  <td class="px-6 py-4 text-sm font-roboto text-gray-800">
                    {pro.tax} {pro.tax ? "%" : ""}
                  </td>
                  <td class="px-6 py-4 text-sm font-roboto text-gray-800">
                    {pro.discount} {pro.discountType}
                  </td>
                </tr>
              </tbody>
            ))}
          </table>
          <div className="mt-5 flex justify-between w-full px-5 ">
            <div className="flex justify-between items-start w-[70%] mx-auto"></div>
            <div className="w-64 flex flex-row justify-between ">
              <div className="flex flex-col gap-1">
                <div className="flex flex-row justify-between w-56">
                  <td class="px-6 py-4 flex justify-center items-center text-sm font-roboto text-gray-800"></td>
                </div>
                <div className="flex flex-row justify-between w-full border-b border-gray-400 bg-gray-50 px-4 py-2">
                  <div>
                    <div>
                      <h1 className="text-sm font-semibold font-roboto text-gray-900">
                        Total Price
                      </h1>
                    </div>
                  </div>
                  <div className="">
                    {products?.modifyTotalAllProductPrice ===
                    products?.totalAllProductPrice ? (
                      <div>
                        <h1 className="text-lg font-semibold font-roboto text-gray-900">
                          {products?.totalAllProductPrice}
                        </h1>
                      </div>
                    ) : (
                      <div>
                        <h1 className="text-lg font-semibold font-roboto text-gray-900">
                          {products?.modifyTotalAllProductPrice}
                        </h1>
                        <h1 className="text-lg font-semibold font-roboto text-gray-900">
                          <del>{products?.totalAllProductPrice}</del>
                        </h1>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-row justify-between w-full border-b border-gray-400 bg-gray-50 px-4 py-2">
                  <h1 className="text-sm font-semibold font-roboto text-gray-600">
                    Discount
                  </h1>
                  <h1 className="text-sm font-semibold font-roboto text-gray-600 ">
                    {products.AllProductDiscount}{" "}
                    {products.AllProductDiscountType}
                  </h1>
                </div>
                <div className="flex flex-row justify-between w-full border-b border-gray-400 bg-gray-50 px-4 py-2">
                  <h1 className="text-sm font-semibold font-roboto text-gray-600">
                    Tax
                  </h1>
                  <h1 className="text-sm font-semibold font-roboto text-gray-600">
                    {products.AllProductTax}
                  </h1>
                </div>
                <div className="flex flex-row justify-between w-full border-b border-gray-400 bg-gray-50 px-4 py-2">
                  <h1 className="text-sm font-semibold font-roboto text-gray-600">
                    Total
                  </h1>
                  {/* <h1 className="text-sm font-semibold font-roboto text-gray-600">
                          {products.UpdateModifyTotalProducts}
                        </h1> */}
                  <div className="">
                    {Number(products?.modifyTotalAllProductPrice) ===
                    Number(products?.UpdateModifyTotalProducts) ? (
                      <div>
                        <h1 className="text-lg font-semibold font-roboto text-gray-900">
                          {products?.UpdateModifyTotalProducts}
                        </h1>
                      </div>
                    ) : (
                      <div>
                        <h1 className="text-lg font-semibold font-roboto text-gray-900">
                          {products?.UpdateModifyTotalProducts}
                        </h1>
                        <h1 className="text-lg font-semibold font-roboto text-gray-900">
                          <del>{products?.modifyTotalAllProductPrice}</del>
                        </h1>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerView;
